import config from "@/config/config";

/**
 * @description 微信授权
 */
let wechatAuthorization = (enterType = 2) => {
    let redirectUri = window.encodeURI(
        `${config.WEB_DOMAIN_NAME}account/login/wechat`
    );
    let authorizationUri = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${config.WECHAT_APPID}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_userinfo&state=${enterType}#wechat_redirec`;
    window.location.href = authorizationUri;
};

export default wechatAuthorization;
